:host{display:flex;gap:8px;color:#232426;opacity:.6}.breadcrumb-divider{color:#232426;opacity:.12}.label-container.danger{color:#e31c3d}
/*# sourceMappingURL=last-saved-badge.component.css.map */
